module.exports = __webpack_public_path__ + "static/media/bm.f1af119a.svg";